module.exports = __webpack_public_path__ + "static/media/copy.727dbbc7.svg";